import * as React from 'react';
import Picky from 'react-picky';
import Select, { components } from 'react-select';
import { connect } from 'react-redux';
import { ConnectedFilterTags } from './filter-tags'

import { FilterBase, mapDispatchToProps, mapStateToProps } from './filter-base';


export class FilterMultiSelectDropdown extends FilterBase {

    convertEvtToString(evt: React.ChangeEvent<HTMLSelectElement>) {
        return evt.target.value;
    }

    submitChange(evt: any) {
        if (evt === null || evt.length === 0) {
            this.boundFilterUpdate(null, true)
        }
        else {
            this.boundFilterUpdate(evt.map(option => option.value).join('|'), true);
        }       
    }

    mappedOptions() {
        let optionsToBeRemoved = this.props.selectedOptions.split('|');
        let allAvailableOptions = this.props.options.map(option => { return { value: option.value, label: option.text } });
        optionsToBeRemoved.forEach(option => allAvailableOptions = allAvailableOptions.filter(x => x.value !== option));
        return allAvailableOptions;
    }

    renderFormElement() {
        if (this.props.selectedOptions !== "" && this.props.options.length === 0) {
            this.boundFilterUpdate("", true);
        }
        return (
            <div className="adage-form-field-wrapper">
                {
                    this.props.title ? <label htmlFor={this.props.title.replace(/ /g, '')}>{this.props.title}</label> : null
                }
                <Select
                    className="filter-select"
                    defaultValues={this.props.selectedOptions != "" ? this.props.selectedOptions.split('|').map(option => { return { value: option, label: option } }) : null}
                    value={this.props.selectedOptions != "" ? this.props.selectedOptions.split('|').map(option => { return { value: option, label: option } }) : null}
                    onChange={this.submitChange.bind(this)}
                    options={this.mappedOptions()}
                    isMulti={true}
                    isDisabled={this.props.IsDisabled}
                    placeholder={this.props.defaultOption.text}
                />
                <ConnectedFilterTags property={this.props.property} />
            </div>
        );
    }
}

export const ConnectedFilterMultiSelectDropdown = connect(mapStateToProps, mapDispatchToProps)(FilterMultiSelectDropdown);